import React from 'react';
import { IoCloseCircleOutline } from 'react-icons/io5';

function AppliedCoupon({ code, onRemove, isRemoving }) {
  return (
    <div className="bg-green-50 p-3 rounded-lg flex justify-between items-center mb-3">
      <div className="flex items-center gap-2">
        <span className="text-green-600 text-sm font-medium">Applied coupon:</span>
        <span className="font-bold text-sm">{code}</span>
      </div>
      <button
        onClick={onRemove}
        disabled={isRemoving}
        className="text-gray-500 hover:text-red-500 transition-colors"
      >
        <IoCloseCircleOutline className="text-xl" />
      </button>
    </div>
  );
}

export default AppliedCoupon;
